module.exports = __webpack_public_path__ + "icons/ketelkiezer_tussenwoning.svg";